// extracted by mini-css-extract-plugin
export default {"bold-heading-text":"styles_bold-heading-text__9FuoE","privacy-standard__text":"styles_privacy-standard__text__urmZ7"};